import { serverClient } from '@obvio/server'
import {
  PRODUCTS_GRID_2_SELECT,
  PRODUCT_ATTRIBUTES_SELECT,
} from '@obvio/template'

import { schema } from '@/api/schema'
import { PRODUCT_SELECT } from '@/components/Store/StorePage'

import type { AnyObject } from '@obvio/utils'
import type { GetStaticPropsContext, GetStaticPropsResult } from 'next'

export async function getStaticProps(
  ctx: GetStaticPropsContext<{ slug: string }>,
): Promise<GetStaticPropsResult<AnyObject>> {
  const client = await serverClient(schema, { ...ctx, isAdmin: true })

  await client.query('getAllProductAttributes', {
    select: PRODUCT_ATTRIBUTES_SELECT,
  })

  await client.query('getProducts', {
    args: {
      sort: {
        by: 'orderIndex',
        order: 'asc',
      },
      take: 12,
      title: '',
      byAttributes: [],
    },
    select: PRODUCT_SELECT,
  })

  await client.query('getProducts', {
    args: {
      take: 12,
      title: '',
      byAttributes: [],
      sort: {
        by: 'orderIndex',
        order: 'asc',
      },
    },
    select: {
      ...PRODUCTS_GRID_2_SELECT,
      ...PRODUCT_SELECT,
    },
  })

  return {
    ...client.ssrData(),
    revalidate: 100,
  }
}
export { StorePage as default } from '@/components/Store/StorePage'
